import { createTheme } from '@mui/material/styles';

const typographyList = { large:100,h1: 70, h2: 47, h3: 39, h4: 30, h5: 24, h6: 23 }

let AppTheme = {
  palette: {
    primary: {
      main: "#4640B9"
    }, secondary: {
      main: "#111111"
    }
  },
  typography: {
    fontFamily: [
      "Lato", "Roboto", "Helvetica", "Arial", "sans-serif"
    ].join(",")
  },
 
}


AppTheme = createTheme(AppTheme)
Object.keys(typographyList).forEach((item) => {
  AppTheme.typography[item] = {
    fontSize: `${typographyList[item]}px`,
    fontFamily:"Calibre,sans-serif",
    [AppTheme.breakpoints.only("xs")]: {
      fontSize: `${(typographyList[item] * 0.6) > 18 ? typographyList[item] * 0.6 : 18}px`,
    },
    [AppTheme.breakpoints.only("sm")]: {
      fontSize: `${(typographyList[item] * 0.8) > 18 ? typographyList[item] * 0.8 : 18}px`,
    }
  }
})

export default AppTheme